import { FetchWrapper, User } from "../_models/types";
import Storage from "./scormStorage";
import errorDefinition from "./scormErrors";

export default class SCORMAdapter {
  moduleName: string;
  user: User;
  fetchWrapper: any;
  api: string;

  constructor(moduleName: string, user: User, fetchWrapper: FetchWrapper) {
    this.moduleName = moduleName;
    this.user = user;
    this.fetchWrapper = fetchWrapper;
    this.api = `${process.env.REACT_APP_API_URL}/v1/scorm/`;
  }

  LMSInitialize() {
    Storage.setItem("Initialized", true);
    return true;
  }

  LMSFinish() {
    if (!this._isInitialized()) {
      this._setError(301);
      return false;
    }

    // Commit before clearing, but silently
    this.LMSCommit().catch(() => { });

    Storage.setItem("Initialized", false);
    Storage.clearAll();
    return true;
  }

  LMSGetValue(element: string) {
    if (!this._isInitialized()) {
      this._setError(301);
      return false;
    }

    let value = Storage.getItem(element);

    if (value === null) {
      this.fetchWrapper
        .get(`${this.api}get_value/?key=${element}&module_name=${this.moduleName}`)
        .then((response: any) => {
          value = response;
          Storage.setItem(element, response);
        })
        .catch(() => { });
    }

    if (value === null) {
      this._setError(201);
      return "";
    }

    return value;
  }

  LMSSetValue(element: string, value: any) {
    if (!this._isInitialized()) {
      this._setError(301);
      return false;
    }

    Storage.setItem(element, value);
    return true;
  }

  // Clean, silent commit method
  async LMSCommit(): Promise<boolean> {
    if (!this._isInitialized()) {
      this._setError(301);
      return false;
    }

    try {
      let data: any = Storage.getAll();

      if (typeof data === "string") {
        try {
          data = JSON.parse(data);
        } catch {
          data = {};
        }
      }

      delete data["errors"];
      delete data["Initialized"];

      const response = await this.fetchWrapper.post(`${this.api}commit/`, {
        module_name: this.moduleName,
        data: data, // Send the raw JavaScript object
      });

      const isSuccessful =
        response &&
        (response.success === true ||
          response.status === "ok" ||
          response.detail === "Saved" ||
          response.saved === true);

      if (!isSuccessful) {
        this._setError(101);
        return false;
      }

      return true;
    } catch {
      this._setError(101);
      return false;
    }
  }

  LMSGetLastError() {
    let errors = Storage.getItem("errors");
    try {
      const parsed = JSON.parse(errors);
      if (Array.isArray(parsed) && parsed.length > 0) {
        return parsed.pop();
      }
    } catch {
      return 0;
    }
    return 0;
  }

  LMSGetErrorString(errorCode: any) {
    const code = errorCode.toString();
    const error = errorDefinition[code];
    return error ? error["errorString"] : "";
  }

  LMSGetDiagnostic(errorCode: any) {
    const code = errorCode.toString();
    const error = errorDefinition[code];
    return error ? error["diagnostic"] : "";
  }

  _isInitialized() {
    return !!Storage.getItem("Initialized");
  }

  _setError(errorCode: any) {
    const code = errorCode.toString();
    let errors = Storage.getItem("errors");
    if (!errors) errors = "[]";
    try {
      const parsed = JSON.parse(errors);
      parsed.push(code);
      Storage.setItem("errors", JSON.stringify(parsed));
    } catch {
      Storage.setItem("errors", JSON.stringify([code]));
    }
  }
}
